import React from 'react'
import { connect } from 'react-redux'
import { IconLock, IconWarnTriangle } from '@edulastic/icons'
import { END_REASONS, getEditLockSelector } from './ducks'
import { BannerAction, BannerBar, BannerButton } from './styled'

const reload = () => window.location.reload()

export const editLockMessage = (lock) => {
  if (!lock?.active) return null
  const who = lock.holderName || 'Another co-author'
  // ASM-985 AC copy: the same message whether this tab was refused or is only viewing
  const editing = {
    kind: 'locked',
    text: `${who} is editing. After they publish or close the browser tab, refresh this page to edit. You may need to wait a few minutes for the change to appear.`,
  }
  const stale = {
    kind: 'warning',
    text:
      'A new test version was published while you were editing. Your changes were not saved. Reload to get the latest version and continue editing. Reloading will discard your current changes.',
  }
  if (lock.ended) {
    switch (lock.endReason) {
      case END_REASONS.HELD:
        return editing
      case END_REASONS.STALE:
        // a reload of a retired version's id would load it again: go to the newer one
        return lock.activeTestId
          ? {
              ...stale,
              link: `/author/tests/${lock.activeTestId}`,
              linkText: 'Reload',
            }
          : { ...stale, reload: true }
      case END_REASONS.SIGN_IN:
        return {
          text: 'Your sign-in changed. Reload the page to keep editing.',
          reload: true,
        }
      case END_REASONS.ACCESS:
        return { text: 'You no longer have edit access to this test.' }
      default:
        return {
          text: 'Something went wrong. Reload the page to keep editing.',
          reload: true,
        }
    }
  }
  if (lock.acquireState === 'retry' && !lock.heldByThisTab) {
    return {
      text:
        "Couldn't reach the server to start editing. Trying again; you can edit once it answers.",
    }
  }
  if (lock.heldByOther) return editing
  return null
}

const EditLockBanner = ({ lock }) => {
  const message = editLockMessage(lock)
  if (!message) return null
  const Icon = message.kind === 'locked' ? IconLock : IconWarnTriangle
  return (
    <BannerBar data-cy="edit-lock-banner" role="alert">
      <Icon width={20} height={20} aria-hidden="true" />
      <span>
        {message.text}{' '}
        {message.link && (
          // a full page load, as reloading into that version would be
          <BannerAction href={message.link} data-cy="edit-lock-newer-version">
            {message.linkText}
          </BannerAction>
        )}
        {message.reload && (
          <BannerButton
            type="button"
            onClick={reload}
            data-cy="edit-lock-reload"
          >
            Reload
          </BannerButton>
        )}
      </span>
    </BannerBar>
  )
}

export default connect((state) => ({ lock: getEditLockSelector(state) }))(
  EditLockBanner
)
